import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M10.19 10.462L1.199 1.47A.85.85 0 012.4.269l9.59 9.59a.847.847 0 01.248.585.849.849 0 01-.249.626l-9.616 9.615a.851.851 0 11-1.203-1.203l9.02-9.02z" fill="#000" /></svg>);